import { Form, Select } from "antd";
import { countries } from "../constant/Countries";

const { Option } = Select;

export const validateMobileNumber = (_, value) => {
  if (!value) return Promise.resolve();

  const digitCount = (value.match(/\d/g) || []).length;
  const exceedsMaxLength = value.length > 20;
  const exceedsDigitLimit = digitCount > 15;

  if (exceedsMaxLength || exceedsDigitLimit) {
    return Promise.reject(new Error("Please enter a valid mobile number"));
  }

  return Promise.resolve();
};

export const prefixSelector = (fieldName) => (
  <Form.Item name={fieldName ? fieldName : "prefix"} noStyle>
    <Select
      defaultValue="India"
      popupMatchSelectWidth={false}
      style={{ width: 76 }}
      className="mobile-prefix-select"
      optionLabelProp="label"
    >
      {countries?.map((country, i) => (
        <Option
          key={i}
          value={country?.label}
          label={`+${country?.code}`}
        >
          <span className="tw-text-base">{country?.flag}</span>
          <span className="px-2 font-medium"> {country?.label}</span>
          <span className="text-color-a39f9f">+ {country?.code}</span>
        </Option>
      ))}
    </Select>
  </Form.Item>
);

export const normalizeMobileNumber = (value = "") =>
  value.replace(/[^\d+\- ()]/g, "");

export const handleMobileChange = (value, form) => {
  const codeMatch = value.match(/^\+(\d{1,4})/); // matches something like +1, +91, +44

  if (codeMatch) {
    const enteredCode = codeMatch[1]; // extract '1' from '+1'

    const matchedCountry = countries.find((c) => c.code === enteredCode);

    if (matchedCountry) {
      form.setFieldsValue({ prefix: matchedCountry.flag });
    }
  }
};

export const formatAndExtractCountryCode = (input) => {
  if (typeof input !== "string" || !input.trim()) {
    return {
      formattedNumber: "",
      countryCallingCode: "91",
      countryLabel: countries?.find((i) => i?.code === "91")?.label || "",
      numberWithoutCountryCode: "",
    };
  }

  const trimmedInput = input.trim();
  const digitsOnly = trimmedInput.replace(/\D/g, "");

  const formattedNumber = trimmedInput.startsWith("+")
    ? trimmedInput
    : `+${digitsOnly}`;

  const countryCodes = Array.isArray(countries)
    ? countries.map((d) => d?.code).filter(Boolean)
    : [];

  let countryCallingCode = "";
  let numberWithoutCountryCode = digitsOnly;

  for (let i = 1; i <= 4; i++) {
    const code = digitsOnly.substring(0, i);
    if (countryCodes.includes(code)) {
      countryCallingCode = code;
      numberWithoutCountryCode = digitsOnly.slice(i);
      break;
    }
  }

  if (!countryCallingCode) {
    countryCallingCode = "91";
    numberWithoutCountryCode = digitsOnly;
  }

  const countryLabel =
    countries?.find((i) => i?.code === countryCallingCode)?.label || "";

  return {
    formattedNumber,
    countryCallingCode,
    countryLabel,
    numberWithoutCountryCode,
  };
};

